import {
  Box,
  Container,
  Grid,
  InputLabel,
  makeStyles,
  TextField,
  Typography,
  Button,
  Table,
  TableRow,
  TableCell,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { backend } from "../../api";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { Helmet } from "react-helmet";
import { PageBanner } from "../../components";
import { Link, useHistory, useParams } from "react-router-dom";
import { Skeleton } from "@material-ui/lab";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  createBookOrder,
  fetchBookDetails,
} from "../../redux-store/books/actions";
import {
  RESET_BOOK,
  RESET_BOOK_ORDER,
  RESET_PROMOTED_BY,
} from "../../redux-store/constants";
import { addAmount, addAmountMem, getTax, pageCount } from "../../utils";
import {
  checkDeliveryAddress,
  costCalculation,
  costCalculationDelivery,
} from "./LuluCalls";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    margin: "40px 0",
  },
  sectionHeading: {
    fontSize: "36px",
    fontWeight: 600,
  },
  formLabel: {
    color: theme.palette.secondary.light,
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: 600,
  },
  placeSelector: {
    padding: "8px",
    width: "100%",
    borderRadius: "2px",
  },
  inputField: {
    padding: "10px",
    borderRadius: "5px",
    width: "100%",
  },
  shopBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    minWidth: "110px",
    margin: "30px 0",
    fontSize: "16px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 10px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  addressBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    minWidth: "110px",
    fontSize: "16px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 10px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  addressError: {
    color: "red",
  },
  radioBtns: {
    margin: "0",
  },
  radioLabels: {
    fontSize: "14px",
  },
}));

const Checkout = () => {
  const classes = useStyles();
  const { currentUser } = useSelector((state) => state.auth);
  const { currentItem, loading, error } = useSelector((state) => state.book);
  const { order, success } = useSelector((state) => state.bookOrder);
  const { member_user } = useSelector((state) => state.adCards);
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();
  const [billingAddress, setBillingAddress] = useState(
    currentUser?.addresses ? currentUser?.addresses[0] : "ABC"
  );
  const [amounts, setAmounts] = useState();
  const [bookPrice, setBookPrice] = useState(0);
  const [deliveryPrice, setDeliveryPrice] = useState(0);
  const [deliveryType, setDeliveryType] = useState();
  const [taxAmount, setTaxAmount] = useState({ amount: 0, percentage: 0 });
  const [count, setPageCount] = useState(100);
  const [bookType, setBookType] = useState();
  const [address, setAddress] = useState(false);
  const [addressError, setAddressError] = useState("");

  useEffect(() => {
    dispatch({ type: RESET_BOOK });
    if (currentUser?.user) {
      handleFetchCurrentBook(params.bookId);
      handleFetchCurrentAmount();
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentItem) {
      (async () => {
        let pdfLength = await pageCount(currentItem);
        setPageCount(pdfLength);
      })();
    }

    if (success === true) {
      dispatch({ type: RESET_BOOK_ORDER });
      dispatch({ type: RESET_PROMOTED_BY });

      history.push(`/dashboard/customer`);
    }
  }, [success]);

  const handleRequestOrder = () => {
    let delivery;
    let price;
    let total = +bookPrice + +taxAmount.amount + +deliveryPrice;

    if (deliveryType === "standard") {
      delivery = {
        standard_delivery: deliveryPrice,
      };
    } else if (deliveryType === "three_days") {
      delivery = {
        three_days_delivery: deliveryPrice,
      };
    } else if (deliveryType === "next_day") {
      delivery = {
        next_day_delivery: deliveryPrice,
      };
    }
    if (bookType === "paper_back") {
      price = {
        paperback_price: bookPrice,
      };
    } else if (bookType === "hard_cover") {
      price = {
        hardcover_price: bookPrice,
      };
    }
    const newOrder = {
      total_price: +total,
      book_price: price,
      status: "requested",
      source_of_approaching: "family",
      user: currentUser.user._id,
      member_id: member_user ? member_user : null,

      book: params.bookId,
      shipping_address: {
        country: billingAddress.country,
        state: billingAddress.state,
        city: billingAddress.city,
        zip: billingAddress.zip,
        name: billingAddress.name,
      },
      billing_details: {
        payment_type: "paypal",
        delivery_type: currentItem.print_on_demand,
        delivery_amount: deliveryPrice,
        delivery: delivery,
        tax_amount: {
          percentage: taxAmount.percentage,
          amount: taxAmount.amount,
        },
      },
    };
    dispatch(createBookOrder(newOrder));
  };
  const handleFetchCurrentBook = (id) => {
    dispatch(fetchBookDetails(id));
  };
  const handleFetchCurrentAmount = () => {
    backend.get("/amount").then((res) => {
      setAmounts(res.data.data[0]);
    });
  };
  const handleChangeValues = async (value) => {
    if (value === "hard_cover") {
      if (currentItem.print_on_demand === "admin") {
        let data = await costCalculation(
          currentItem,
          billingAddress,
          currentUser.user,
          "CW",
          amounts,
          count
        );
        let price;
        if (member_user) {
          price = addAmountMem(data.cost, amounts);
          price = addAmount(price, amounts);
        } else {
          price = addAmount(data.cost, amounts);
        }
        setBookPrice(price);
        setBookType(value);
        setTaxAmount({
          amount: data.taxAmount,
          percentage: data.percentage,
        });
        setDeliveryType(null);
        setDeliveryPrice(0);
      } else {
        setBookPrice(currentItem?.price.hardcover_price);
        setBookType(value);
        let tax = getTax(amounts, currentItem, "hardcover_price");
        setTaxAmount({ amount: tax, percentage: amounts.tax });
        setDeliveryType(null);
        setDeliveryPrice(0);
      }
    } else if (value === "paper_back") {
      if (currentItem.print_on_demand === "admin") {
        let data = await costCalculation(
          currentItem,
          billingAddress,
          currentUser.user,
          "PB",
          amounts,
          count
        );
        let price;
        if (member_user) {
          price = addAmountMem(data.cost, amounts);
          price = addAmount(price, amounts);
        } else {
          price = addAmount(data.cost, amounts);
        }
        setBookPrice(price);
        setBookType(value);
        setTaxAmount({
          amount: data.taxAmount,
          percentage: data.percentage,
        });
        setDeliveryType(null);
        setDeliveryPrice(0);
      } else {
        setBookPrice(currentItem?.price.paperback_price);
        setBookType(value);
        setDeliveryType(null);
        setDeliveryPrice(0);
        let tax = getTax(amounts, currentItem, "paperback_price");
        setTaxAmount({ amount: tax, percentage: amounts.tax });
      }
    }
  };

  const handleDeliveryType = async (val) => {
    if (val === "next_day") {
      if (currentItem.print_on_demand === "admin") {
        let data = await costCalculationDelivery(
          currentItem,
          billingAddress,
          currentUser.user,
          "next_day_delivery",
          count
        );
        setDeliveryPrice(data);
      } else {
        setDeliveryPrice(currentItem?.delivery.next_day_delivery);
      }
    } else if (val === "three_days") {
      if (currentItem.print_on_demand === "admin") {
        let data = await costCalculationDelivery(
          currentItem,
          billingAddress,
          currentUser.user,
          "three_days_delivery",
          count
        );
        setDeliveryPrice(data);
      } else {
        setDeliveryPrice(currentItem?.delivery.three_days_delivery);
      }
    } else {
      if (currentItem.print_on_demand === "admin") {
        let data = await costCalculationDelivery(
          currentItem,
          billingAddress,
          currentUser.user,
          "standard_delivery",
          count
        );
        setDeliveryPrice(data);
      } else {
        setDeliveryPrice(currentItem?.delivery.standard_delivery);
      }
    }
    setDeliveryType(val);
  };

  const submitAddress = async () => {
    if (currentItem.print_on_demand == "admin" && address == false) {
      const valid = await checkDeliveryAddress(
        currentItem,
        billingAddress,
        currentUser.user,
        "standard_delivery",
        count
      );
      if (Boolean(valid)) {
        setAddress(!address);
        setBookType(null);
        setBookPrice(0);
        setDeliveryType(null);
        setDeliveryPrice(0);
        setTaxAmount({ amount: 0, percentage: 0 });
        setAddressError("");
      } else {
        setAddressError(
          "Either the postal code doesn't match country and state or We are unable to deliver to your current address."
        );
      }
    } else {
      setAddressError("");
      setAddress(!address);
      setBookType(null);
      setBookPrice(0);
      setDeliveryType(null);
      setDeliveryPrice(0);
      setTaxAmount({ amount: 0, percentage: 0 });
    }
  };
  return (
    <Fragment>
      <Helmet>
        <title>Checkout - d2p</title>
      </Helmet>
      <PageBanner title="Checkout" image="/assets/images/bg4.jpg" />
      <ToastContainer />
      {currentUser?.user && currentUser.user.role === "customer" ? (
        <Container>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              submitAddress();
            }}
          >
            <div className={classes.root}>
              <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                  <h2 className={classes.sectionHeading}>Billing Address</h2>
                  {currentUser?.user && billingAddress && (
                    <>
                      <Box mb={2}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <InputLabel className={classes.formLabel}>
                              Country
                            </InputLabel>
                            <CountryDropdown
                              valueType="short"
                              name="country"
                              className={classes.inputField}
                              value={billingAddress.country}
                              onChange={(_, e) => {
                                setBillingAddress({
                                  ...billingAddress,
                                  country: e.target.value,
                                });
                              }}
                              required
                              disabled={Boolean(address)}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <InputLabel className={classes.formLabel}>
                              State
                            </InputLabel>
                            <RegionDropdown
                              className={classes.inputField}
                              name="state"
                              countryValueType="short"
                              country={billingAddress.country}
                              value={billingAddress.state}
                              required
                              onChange={(_, e) => {
                                setBillingAddress({
                                  ...billingAddress,
                                  state: e.target.value,
                                });
                              }}
                              disabled={Boolean(address)}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                      <Box mb={2}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <InputLabel className={classes.formLabel}>
                              City / Town
                            </InputLabel>
                            <TextField
                              variant="outlined"
                              type="text"
                              required
                              className={classes.inputField}
                              value={billingAddress.city}
                              name="city"
                              onChange={(e) => {
                                setBillingAddress({
                                  ...billingAddress,
                                  city: e.target.value,
                                });
                              }}
                              disabled={Boolean(address)}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <InputLabel className={classes.formLabel}>
                              ZIP
                            </InputLabel>
                            <TextField
                              variant="outlined"
                              type="text"
                              className={classes.inputField}
                              value={billingAddress.zip}
                              name="zip"
                              required
                              onChange={(e) => {
                                setBillingAddress({
                                  ...billingAddress,
                                  zip: e.target.value,
                                });
                              }}
                              disabled={Boolean(address)}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                      <Box mb={2}>
                        <InputLabel className={classes.formLabel}>
                          Street Address
                        </InputLabel>
                        <TextField
                          variant="outlined"
                          type="text"
                          required
                          className={classes.inputField}
                          value={billingAddress.name}
                          name="street"
                          onChange={(e) => {
                            setBillingAddress({
                              ...billingAddress,
                              name: e.target.value,
                            });
                          }}
                          disabled={Boolean(address)}
                        />
                      </Box>
                    </>
                  )}
                </Grid>
              </Grid>
              <Button className={classes.addressBtn} type="submit">
                {Boolean(address) ? "Change Address" : "Submit"}
              </Button>
              <div className={classes.addressError}>
                {addressError !== "" ? addressError : ""}
              </div>
            </div>
          </form>
          <h2 className={classes.sectionHeading}>Your Order</h2>
          {currentItem && address == true ? (
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={3} style={{ textAlign: "center" }}>
                <img
                  src={currentItem.book_cover}
                  style={{ maxWidth: "80%" }}
                  alt=""
                />
                <h3>{currentItem.book_title}</h3>
              </Grid>
              <Grid item xs={12} md={8} lg={9}>
                <Table>
                  <TableRow>
                    <TableCell>
                      <h4>Book Type</h4>
                      <FormControl>
                        <RadioGroup
                          value={bookType}
                          name="book type"
                          onChange={(e) => handleChangeValues(e.target.value)}
                        >
                          {currentItem.book_types == "all" && (
                            <>
                              <FormControlLabel
                                className={classes.radioBtns}
                                value="hard_cover"
                                control={<Radio size="small" />}
                                label={
                                  <span className={classes.radioLabels}>
                                    Limited Edition Hard Back
                                  </span>
                                }
                              />
                              <FormControlLabel
                                className={classes.radioBtns}
                                value="paper_back"
                                control={<Radio size="small" />}
                                label={
                                  <span className={classes.radioLabels}>
                                    Paper Back
                                  </span>
                                }
                              />
                            </>
                          )}
                          {currentItem.book_types === "hardcover" && (
                            <>
                              <FormControlLabel
                                className={classes.radioBtns}
                                value="hard_cover"
                                control={<Radio size="small" />}
                                label={
                                  <span className={classes.radioLabels}>
                                    Limited Edition Hard Back
                                  </span>
                                }
                              />
                            </>
                          )}
                          {currentItem.book_types == "paperback" && (
                            <>
                              <FormControlLabel
                                className={classes.radioBtns}
                                value="paper_back"
                                control={<Radio size="small" />}
                                label={
                                  <span className={classes.radioLabels}>
                                    Paper Back
                                  </span>
                                }
                              />
                            </>
                          )}
                        </RadioGroup>
                      </FormControl>
                    </TableCell>
                    <TableCell>$ {bookPrice.toFixed(2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <h4>Delivery Options</h4>
                      <FormControl>
                        <RadioGroup
                          value={deliveryType}
                          name="Delivery"
                          onChange={(e) => handleDeliveryType(e.target.value)}
                        >
                          <FormControlLabel
                            className={classes.radioBtns}
                            value={"next_day"}
                            checked={deliveryType == "next_day"}
                            control={<Radio size="small" />}
                            label={
                              <span className={classes.radioLabels}>
                                Next Day
                              </span>
                            }
                          />
                          <FormControlLabel
                            className={classes.radioBtns}
                            value={"three_days"}
                            checked={deliveryType == "three_days"}
                            control={<Radio size="small" />}
                            label={
                              <span className={classes.radioLabels}>
                                3 days
                              </span>
                            }
                          />
                          <FormControlLabel
                            className={classes.radioBtns}
                            value={"standard"}
                            checked={deliveryType == "standard"}
                            control={<Radio size="small" />}
                            label={
                              <span className={classes.radioLabels}>
                                Standard
                              </span>
                            }
                          />
                        </RadioGroup>
                      </FormControl>
                    </TableCell>
                    <TableCell>$ {deliveryPrice.toFixed(2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <h4>Tax </h4>
                    </TableCell>
                    <TableCell>$ {taxAmount.amount.toFixed(2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <h4>Total</h4>
                    </TableCell>
                    <TableCell>
                      <h4>
                        ${" "}
                        {(
                          +deliveryPrice +
                          +bookPrice +
                          +taxAmount.amount
                        ).toFixed(2)}
                      </h4>
                    </TableCell>
                  </TableRow>
                </Table>
              </Grid>
            </Grid>
          ) : (
            <Box align="center">
              <Skeleton animaion="wave" />
            </Box>
          )}
          <div>
            <Box display="flex" alignItems="center" flexWrap="wrap">
              <h4>PayPal</h4>
              <img
                src="https://www.paypalobjects.com/webstatic/mktg/logo/AM_mc_vs_dc_ae.jpg"
                alt=""
                style={{ margin: "0 10px" }}
              />
              <h4>What is PayPal?</h4>
            </Box>
            <p>
              Pay via PayPal; you can pay with your credit card if you don’t
              have a PayPal account.
            </p>
            <p>
              Your personal data will be used to process your order, support
              your experience throughout this website, and for other purposes
              described in our privacy policy.
            </p>
            <Button
              className={classes.shopBtn}
              disabled={!bookType || !deliveryType}
              onClick={handleRequestOrder}
            >
              Proceed to PayPal
            </Button>
          </div>
        </Container>
      ) : (
        <Container>
          <Box my={5} textAlign="center">
            <Typography
              variant="body1"
              color="error"
              style={{ fontWeight: 600, fontSize: 36, lineHeight: 1 }}
            >
              You need to Login as Customer before Checkout
            </Typography>
          </Box>
        </Container>
      )}
    </Fragment>
  );
};

export default Checkout;
